// Resolves backend media (avatars, uploads) to a URL that works in both the web
// app and the Capacitor shell, where relative paths would resolve against the
// local webview origin instead of the API.
const PASSTHROUGH = /^(blob:|data:|https:)/i;

const getApiBase = () => String(process.env.REACT_APP_API_BASE_URL || '').replace(/\/+$/, '');

export const resolveMediaUrl = (value) => {
    if (typeof value !== 'string') return value;
    const url = value.trim();
    if (!url) return url;
    if (PASSTHROUGH.test(url)) return url;

    const base = getApiBase();

    if (/^http:\/\//i.test(url)) {
        // The backend can persist http:// URLs when it sits behind a TLS proxy.
        // Browsers silently upgrade these on an https page; Android (cleartext
        // disabled) does not. Upgrade only when it points at our own https API.
        try {
            const target = new URL(url);
            const apiUrl = new URL(base);
            if (apiUrl.protocol === 'https:' && target.host === apiUrl.host) {
                target.protocol = 'https:';
                return target.toString();
            }
        } catch (e) {
            // fall through and return unchanged
        }
        return url;
    }

    if (/^[a-z][a-z0-9+.-]*:/i.test(url) || url.startsWith('//')) return url;
    if (!base) return url;

    return `${base}/${url.replace(/^\/+/, '')}`;
};

export default resolveMediaUrl;
